import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import DocModal from "./DocModal";
import { formatNumber } from "../../../../../../utility/helper";
import { getLegacyDocService } from "../../../../../../services/viewWealth";
import { useSelector } from "react-redux";
import LegacyCardSkeleton from "./LegacyCardSkeleton";

const LegacyComponent = ({ leagcyData, loading }) => {
  const data = leagcyData || [];
  const [showModal, setShowModal] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [docLoading, setDocLoading] = useState(false);
  const [docListData, setDocListData] = useState([]);

  useEffect(() => {
    if (currentDoc) {
      GetLegacyDocData(currentDoc?.item_id);
    }
  }, [currentDoc]);

  const handleEyeClick = (item) => {
    setCurrentDoc(item);
    setShowModal(true);
  };

  const GetLegacyDocData = async (currentDoc) => {
    setDocLoading(true);
    try {
      const response = await getLegacyDocService(currentDoc, accessToken);
      if (response.status === 200) {
        setDocListData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDocLoading(false);
    }
  };

  const isEmpty =
    data?.length === 0 || data?.every((legacy) => !legacy.data?.length);

  const { currency } = useSelector((state) => state.user);

  return (
    <div className="w-full pl-4">
      <h2 className="text-2xl font-semibold text-lightPrimary mb-3 mt-5 text-black dark:text-primary-gradient inline-block">
        Legacy
      </h2>
      {loading ? (
        <LegacyCardSkeleton count={6} rowsPerCard={4} />
      ) : isEmpty ? (
        <div className="text-center text-info dark:text-grey w-full">
          No data available
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-x-12 xl:gap-y-10 w-full items-stretch">
          {data?.map((legacy, i) => (
            <div
              key={i}
              className="flex flex-col border border-lightPrimary/40 dark:border-info/40 p-4 rounded-sm dark:bg-card-custom-radials bg-[length:400%_200%] bg-white min-h-[17rem] h-full"
            >
              <div className="font-medium text-lg text-lightPrimary dark:text-primary-gradient mb-3 border-b border-lightPrimary/40 dark:border-info/40 pb-2">
                {legacy?.legacy_name}
              </div>
              <div className="flex flex-col mb-2">
                <table className="table-fixed w-full text-sm border-collapse">
                  <thead className="sticky top-0 z-10">
                    <tr>
                      <th className="px-4 py-2 text-left w-1/3 text-info dark:text-grey font-medium">
                        Name
                      </th>
                      <th className="px-4 py-2 text-left w-1/3 text-info dark:text-grey font-medium">
                        Current Amount
                      </th>
                      <th className="py-2 text-left w-1/3 text-info dark:text-grey text-end ps-4 pe-6 font-medium">
                        Doc
                      </th>
                    </tr>
                  </thead>
                </table>
                <div className="max-h-28 overflow-y-auto">
                  <table className="table-fixed w-full text-sm border-collapse">
                    <tbody>
                      {legacy.data?.length ? (
                        legacy.data.map((itemData, idx) => (
                          <tr key={idx}>
                            <td className="px-4 py-2 text-lightPrimary dark:text-primary-gradient break-all">
                              {itemData?.item_name || "-"}
                            </td>

                            <td className="px-4 py-2 font-medium text-lightPrimary dark:text-primary-gradient break-all">
                              {formatNumber(itemData?.initial_amount) || 0}{" "}
                              {currency || ""}
                            </td>

                            <td className="ps-4 pe-6 py-2 text-end break-all">
                              {itemData && (
                                <span className="flex justify-end">
                                  <FaEye
                                    className="cursor-pointer text-primary"
                                    onClick={() => handleEyeClick(itemData)}
                                  />
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center py-4 text-info dark:text-grey"
                          >
                            No Items
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="font-medium text-sm border-t border-lightPrimary/40 dark:border-info/40 pt-2 mt-auto">
                <table className="table-fixed w-full text-sm border-collapse">
                  <tbody>
                    <tr>
                      <td className="px-4 py-2 text-lightPrimary dark:text-primary-gradient">
                        Total
                      </td>
                      <td className="px-4 py-2 text-lightPrimary dark:text-primary-gradient break-all">
                        {formatNumber(legacy?.total_initial_amount) || 0}{" "}
                        {currency || ""}
                      </td>
                      <td className="ps-4 pe-6 py-2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <DocModal
          docData={currentDoc}
          docListData={docListData}
          onClose={() => {
            setShowModal(false);
            setCurrentDoc(null);
            setDocListData([]);
          }}
          docLoading={docLoading}
        />
      )}
    </div>
  );
};

export default LegacyComponent;
